import React from 'react';
import { Breadcrumb } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import { RightOutlined } from '@ant-design/icons'

export const CustomBreadcrumb = () => {
  const location = useLocation()
  const pathSnippets = location.pathname.split('/').filter((i) => i)

  function convertToTitleCase(str: string) {
    const exceptions = ['of', 'the', 'and']

    if (!str) {
      return ''
    }

    return str
      .toLowerCase()
      .split(' ')
      .map((word, i) => {
        return exceptions.includes(word) && i !== 0 ? word : word.charAt(0).toUpperCase().concat(word.substr(1))
      })
      .join(' ')
  }

  const homeBreadcrumb = {
    title: <Link to='/'>Home</Link>,
    key: 'home',
  }

  const breadcrumbs = pathSnippets.map((pathname, index) => {
    const routeTo = `/${pathSnippets.slice(0, index + 1).join('/')}`
    const isLast = index === pathSnippets.length - 1
    let sanitizedPathname = convertToTitleCase(pathname.replace(/-/g, ' '))

    return {
      key: routeTo,
      title: isLast ? <span>{sanitizedPathname}</span> : <Link to={routeTo}>{sanitizedPathname}</Link>,
    }
  })

  if (breadcrumbs[0]?.key === '/home') {
    breadcrumbs.shift()
  }
  const items = [homeBreadcrumb, ...breadcrumbs]

  return (
    <>
      <Breadcrumb separator={<RightOutlined />} items={items} />
    </>
  )
}
